"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HeadManagerContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const HeadManagerContext = _react.default.createContext({});
exports.HeadManagerContext = HeadManagerContext;
if (process.env.NODE_ENV !== "production") {
    HeadManagerContext.displayName = "HeadManagerContext";
}

//# sourceMappingURL=head-manager-context.js.map